import Section from "../pages/Main/Section";
import styles from "./ProductInfo.module.css";
import ImageComponent from "./ImageComponent";
import Paragraph, { ParagraphSize } from "./Paragraph";
import React from "react";
import clsx from "clsx";

interface InfoDataProps {
  title: string;
  description: string;
  icon: string;
}

interface ProductInfoProps {
  itemList: {
    overlayList: any[];
    backgroundImg: string[];
    infoList: any[];
  };
  black1100?: boolean;
}

const ProductInfo: React.FC<ProductInfoProps> = ({
  itemList,
  black1100 = false,
}) => {
  const InfoData: React.FC<InfoDataProps> = ({ title, description, icon }) => {
    return (
      <div className={styles["data-main-container"]}>
        <div
          className={clsx(
            styles["data-container"],
            black1100 && styles["black1100"]
          )}
        >
          <ImageComponent src={icon} />

          <Paragraph
            size={ParagraphSize.paragraph1}
            classNameStyle={styles["white-text"]}
          >
            {title}
          </Paragraph>
          <Paragraph
            size={ParagraphSize.paragraph2}
            classNameStyle={styles["remove-margin"]}
          >
            {description}
          </Paragraph>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        className={styles["relative-container"]}
        style={{
          backgroundImage: `url(${itemList.backgroundImg})`,
        }}
      >
        <Section overlays={itemList.overlayList} />
        <div className={styles["joker-info-container"]}>
          <div className={styles.container}>
            <div
              className={clsx(
                styles.sub_container,
                black1100 && styles["black1100"]
              )}
            ></div>
            <div
              className={clsx(
                styles.info_container,
                black1100 && styles["black1100"]
              )}
            >
              <div className={styles["info-view"]}>
                {itemList.infoList.map((data, index) => (
                  <InfoData
                    key={index}
                    title={data.title}
                    description={data.description}
                    icon={data.icon}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductInfo;
